// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1UJUX","buttons":"SendReceipts_buttons__1LHBp","email":"SendReceipts_email__2llz_","bookApptTitle":"SendReceipts_bookApptTitle__3-LRo"};